<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    @ok="handleCancel"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :footer="null"
    @cancel="handleCancel"
    cancelText="关闭">

    <div class="follow-box" v-if="qrcode">
      <div class="follow-qrcode">
        <img :src="qrcode" v-if="qrcode">
        <img v-else src="@/assets/driver/loading.gif"/>
      </div>
      <div class="follow-tips">
        <p>注意事项：</p>
        <p>1）拖动或复制左侧二维码发送至司机微信邀请关注；</p>
        <p>2）一人一码，请确认二维码发送至司机本人，以免造成账号安全问题</p>
      </div>
    </div>

<div class="detection-title">
  <span>检测日期</span>
  <span>检测行为</span>
</div>
    <div class="detection-list">
      <div class="detection-item" v-for="item in data">
        <div>{{item.createTime}}</div>
        <div class="detection-behavior">
          <img class="operator-avatar" :title="item.createName" :src="getFileAccessHttpUrl(item.createAvatar)" v-if="item.createAvatar && item.type==0"/>
          <div class="behavior-type" v-if="item.type==0">发起邀请码</div>
          <div class="behavior-type" v-if="item.type==1">司机关注</div>
          <div class="behavior-type" v-if="item.type==2">司机取消关注</div>
        </div>
      </div>
    </div>
  </j-modal>
</template>

<script>
  import { getFileAccessHttpUrl, getAction } from '@/api/manage'
  export default {
    name: 'JcRecordModal',
    components: {

    },
    data () {
      return {
        title:'公众号检测记录',
        width:580,
        visible: false,
        disableSubmit: false,
        data:[],
        getFileAccessHttpUrl:getFileAccessHttpUrl,
        qrcode:""
      }
    },
    methods: {
      show (driverId,hasSubscribe) {
        this.visible=true;
        let formData = {
          "driverId":driverId,
          "pageNo":1,
          pageSize:1000
        }
        getAction("/dm/dmWxOperate/list",formData).then((res)=>{
          if(res.success){
            this.data = res.result.records;
          }
        })
        //if(hasSubscribe){
          let fd = {
            "id":driverId,
            "bg":driverId
          }
          getAction("/dm/dmDriver/queryCodeById",fd).then((res)=>{
            if(res.success){
              this.qrcode = getFileAccessHttpUrl(res.result.wxCode);
            }
          })
        //}
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style lang="less" scoped>
  .follow-box{
    display: flex;
    gap: 25px;
  }
  .follow-qrcode img{
    width: 141px;
  }
  .follow-tips{
    font-size: 16px;
    color: rgba(125, 133, 146, 1);
  }
  .detection-title{
    padding: 24px 0;
    display: flex;
    color: #7D8592;
    font-size: 16px;
    border-bottom: 1px solid #E4E6E8;
  }
  .detection-title>span{
    flex: 1;
    text-align: center;
  }
  .detection-list{
    max-height: 200px;
    overflow-y: auto;
  }
  .detection-item{
    display: flex;
    margin-top: 16px;
    color: #0A1629;
    font-size: 16px;
  }
  .detection-item>div{
    flex: 1;
    text-align: center;
  }
  .detection-behavior{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .operator-avatar{
    margin-right: 8px;
    width: 24px;
    height: 24px;
    background-color: pink;
    border-radius: 50%;
  }

  .follow-box{
    display: flex;
    gap: 25px;
  }
  .follow-qrcode img{
    width: 141px;
  }
  .follow-tips{
    font-size: 16px;
    color: rgba(125, 133, 146, 1);
  }
</style>